import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const certificates = [
  { src: '/certeficate.jpg', title: 'Certificate' },
];

const recommendations = [
  { src: '/recommendation.jpg', title: 'Recommendation Letter' },
];

export default function CvCertificates() {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeGroup, setActiveGroup] = useState([]);
  const [activeTitle, setActiveTitle] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);

  const openModal = (group, title) => {
    setActiveGroup(group);
    setActiveTitle(title);
    setCurrentIndex(0);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setActiveGroup([]);
    setActiveTitle('');
    setCurrentIndex(0);
  };

  const paginate = (dir) => {
    setDirection(dir);
    setCurrentIndex((prev) =>
      (prev + dir + activeGroup.length) % activeGroup.length
    );
  };

  const imageVariants = {
    enter: (dir) => ({
      x: dir > 0 ? 300 : -300,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
    },
    exit: (dir) => ({
      x: dir > 0 ? -300 : 300,
      opacity: 0,
    }),
  };

  return (
    <section id="cv" className="py-20 bg-gradient-to-br from-purple-50 to-indigo-50 px-6 md:px-20">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-indigo-900 mb-8">CV, Certificates & Recommendations</h2>

        <a
          href="/cv.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-indigo-600 text-white py-3 px-6 rounded-full mb-12 shadow hover:bg-indigo-700 transition"
        >
          Download CV
        </a>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <motion.div
            className="relative group rounded-xl overflow-hidden shadow-lg"
            whileHover={{ scale: 1.02 }}
          >
            <img
              src={certificates[0].src}
              alt="Certificate Preview"
              className="w-full h-64 object-cover blur-sm group-hover:blur-none transition duration-300"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black/30 opacity-0 group-hover:opacity-100 transition">
              <button
                onClick={() => openModal(certificates, 'Certificates')}
                className="bg-indigo-600 text-white py-2 px-6 rounded-full font-semibold hover:bg-indigo-700 shadow"
              >
                View Certificates
              </button>
            </div>
          </motion.div>

          <motion.div
            className="relative group rounded-xl overflow-hidden shadow-lg"
            whileHover={{ scale: 1.02 }}
          >
            <img
              src={recommendations[0].src}
              alt="Recommendation Preview"
              className="w-full h-64 object-cover blur-sm group-hover:blur-none transition duration-300"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black/30 opacity-0 group-hover:opacity-100 transition">
              <button
                onClick={() => openModal(recommendations, 'Recommendations')}
                className="bg-indigo-600 text-white py-2 px-6 rounded-full font-semibold hover:bg-indigo-700 shadow"
              >
                View Recommendations
              </button>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <div
            className="relative max-w-3xl w-full px-4 py-6 bg-white rounded-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              className="absolute top-2 right-4 text-gray-800 text-2xl font-bold hover:text-red-400"
            >
              &times;
            </button>
            <h3 className="text-center text-xl font-semibold text-indigo-800 mb-6">{activeTitle}</h3>

            <div className="relative h-[60vh] flex items-center justify-center overflow-hidden">
              <AnimatePresence custom={direction} mode="wait">
                <motion.img
                  key={currentIndex}
                  src={activeGroup[currentIndex].src}
                  alt={activeGroup[currentIndex].title}
                  custom={direction}
                  variants={imageVariants}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  transition={{ duration: 0.6 }}
                  className="absolute max-h-full w-auto max-w-full rounded-xl shadow-lg object-contain"
                />
              </AnimatePresence>
            </div>

            {/* Prev / Next */}
            {activeGroup.length > 1 && (
              <div className="mt-6 flex justify-center gap-6">
                <button
                  onClick={() => paginate(-1)}
                  className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 transition"
                >
                  ⟵ Prev
                </button>
                <button
                  onClick={() => paginate(1)}
                  className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 transition"
                >
                  Next ⟶
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
